'use client';

import classNames from 'classnames';
import TrailListItem from './TrailListItem';
import styles from './styles/styles.module.scss';
import { TrailListItemData } from './types/types';
import LoadingListItem from './LoadingListItem';

type TrailListProps = {
  trails: TrailListItemData[];
  variant?: 'primary' | 'inverse';
  isLoading?: boolean;
  hideDesktopArrows?: boolean;
  setIndexHovered?: (index?: number) => void;
};

const TrailList = ({ trails, variant = 'primary', isLoading = false, hideDesktopArrows = false, setIndexHovered }: TrailListProps) => {
  return (
    <ol className={classNames(styles.list, styles[variant])}>
      {isLoading
        ? Array.from({ length: 7 }).map((_, i) => <LoadingListItem key={i} />)
        : trails.map((trail, index) => (
            <TrailListItem
              key={trail.slug}
              index={index}
              trail={trail}
              variant={variant}
              setHovered={() => setIndexHovered && setIndexHovered(index)}
              removeHovered={() => setIndexHovered && setIndexHovered(undefined)}
              hideDesktopArrow={hideDesktopArrows}
            />
          ))}
    </ol>
  );
};

export default TrailList;
